import withName from "../../hoc/withName";
import { TieredMenu } from "primereact/tieredmenu";
import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { Button } from "primereact/button";
import { useState, useEffect } from "react";
import DivPortal from "../Utils/DivPortal";

const BulkEditBtnPrime = ({enabled,divId,  items, openDialog, headerText, onClickBulk=null}) => {

    const [model, setModel] = useState(null);
    const menu = useRef(null);

    useEffect(() => {
        if(items){
            const menu = [];
            Array.isArray(items) && items.forEach((item, i) => {
                menu.push(
                    {
                        label:item.text,
                        template: () => {
                            return (
                                <span className={!item.disabled?"bulkMenuItem":"bulkMenuItem-disabled"} onClick={onClickBulk?onClickBulk:() => {
                                    if(!item.disabled){
                                        const { id, full } = item || {};
                                        if (!id) return;

                                        const allowList = id.split(",");
                                        const data = {};
                                        allowList.forEach(field => data[field] = null);
                                        openDialog({ allowList, data, headerText, visible: true, alert: !full && "forms.notAllValid" });
                                    }
                                }}
                                >
                                    {item.text}
                                </span>
                            );
                        }
                    }
                );

            });
            setModel(menu);
        }
    }, [items]);

    return (
        <DivPortal container={divId}>
            <TieredMenu model={model} popup ref={menu} breakpoint="767px" />
            {enabled ?
                <Button rounded text aria-label="Filter" onClick={(e) => menu.current.toggle(e)} >
                    <FontAwesomeIcon
                        className='btnEdit text-dark' size="lg" icon={faEdit}
                        onClick={(e) => menu.current.toggle(e)}
                    />
                </Button>
                :null}
        </DivPortal>

    );
};

export default withName(BulkEditBtnPrime, "BulkEditBtnPrime");
